var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 34,
    height: 34,
    rx: 7,
    stroke: "#00B8C0",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7501 33.4372L8.33958 21.8554C8.2181 21.742 8.29832 21.5385 8.46449 21.5385C8.50942 21.5385 8.55278 21.555 8.58632 21.5849L20.7688 32.4468C21.6543 33.2362 23.0283 33.0859 23.7221 32.1237L43.7348 4.36781C43.8179 4.25253 44 4.31133 44 4.45345C44 4.48373 43.9906 4.51328 43.9731 4.53801L23.7474 33.1301C23.0477 34.1193 21.636 34.264 20.7501 33.4372Z",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDark);
export default __webpack_public_path__ + "static/media/selected-dark.5bbc130c91e718ffdba1de38fde17cea.svg";
export { ForwardRef as ReactComponent };